{
  "colorSwatchPicker": "Krāsu paraugi",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Izvēlēties vienumu",
  "tableResizer": "Izmēra mainītājs"
}
